<template>
  <div class="bg-white p-2">
    <TabIndicator :index="getBookingTabId" />

    <KeepAlive>
      <component
        :is="IsComponent"
        @changeBookingTab="changeBookingTab"
      ></component>
    </KeepAlive>
  </div>
</template>

<script>
import TabIndicator from "./module/TabIndicator.vue";

import Reciever from "./module/Reciever.vue";
import Sender from "./module/Sender.vue";
import Packages from "./module/packages/LightPackage.vue";
import Prefrence from "./module/prefrence/PrefrenceModule.vue";
import BookingDetails from "./module/prefrence/BookingDetails.vue";
import BookingConfirmation from "./module/BookingConfirmation.vue";

export default {
  components: {
    TabIndicator,

    Sender,
    Reciever,
    Packages,
    Prefrence,
    BookingDetails,
    BookingConfirmation,
  },
  data() {
    return {
      bookingTabIndex: undefined,
    };
  },

  methods: {
    changeBookingTab(val) {
      this.$store.dispatch("saveLatestNewBookinTabNum", val);
      this.bookingTabIndex = this.getBookingTabId;
    },
  },
  mounted() {
    this.$store.dispatch("saveLatestNewBookinTabNum", 1);
  },

  computed: {
    getBookingTabId() {
      return this.$store.getters.latestNewBookingTab;
    },

    IsComponent() {
      let component;
      switch (Number(this.getBookingTabId)) {
        case 1:
          component = "sender";
          break;
        case 2:
          component = "reciever";

          break;
        case 3:
          component = "packages";
          break;
        case 4:
          component = "prefrence";
          break;
        case 5:
          component = "booking-details";
          break;
        case 7:
          component = "booking-confirmation";
          break;
        default:
          component = "sender";

          break;
      }
      return component;
    },
  },
};
</script>

<style lang="scss" scoped></style>
